import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const dealerDevicesApi = createApi({
  reducerPath: "dealerDevices",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      getDealerRolesDeviceDetail: builder.query({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceDetail",
            "POST"
          );
        },
      }),
      getDealerRolesDeviceDistribution: builder.query({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceDistribution",
            "POST"
          );
        },
      }),
      getDealerRolesDeviceConsumentStats: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceConsumentStats",
            "POST"
          );
        },
      }),
      // Rapor sekmesi → Tüketim (#343)
      getDealerRolesDeviceDetailPerformanceReport: builder.mutation({
        query: (data) =>
          apiFunction(data, "/api/devices/dealerRoles/performance-report", "POST"),
      }),
      getDealerRolesDeviceConsumentLogsforReport: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceConsumentLogsforReport",
            "POST"
          );
        },
      }),
      getDealerRolesDeviceSettingLogsforReport: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceSettingLogsforReport",
            "POST"
          );
        },
      }),
      getDealerRolesDeviceOperationLogsforReport: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceOperationLogsforReport",
            "POST"
          );
        },
      }),
      getDealerRolesDeviceSettingLogsPaginated: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceSettingLogsPaginated",
            "POST"
          );
        },
      }),
      getDealerRolesDeviceOperationLogsPaginated: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/devices/dealerRoles/getDeviceOperationLogsPaginated",
            "POST"
          );
        },
      }),
      // ─── Dealer Cihaz Durum Aksiyonları ─────────────────────
      dealerToggleDeviceActivity: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/toggleDeviceActivity", "PATCH");
        },
      }),
      dealerMoveDeviceToFirm: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/moveDeviceToFirm", "PATCH");
        },
      }),
      dealerMoveDeviceToPlaymaker: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/moveDeviceToPlaymaker", "PATCH");
        },
      }),
      dealerMoveDeviceToService: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/moveDeviceToService", "PATCH");
        },
      }),
      dealerMoveDeviceToStorage: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/moveDeviceToStorage", "PATCH");
        },
      }),
      // ─── Cihaz Bazında Kota Ver / Geri Al ────────────────────
      // Firma bakiyesi (dağıtılmayan kota) ile TEK cihaz arasında elle miktar
      // belirterek transfer; toplam kota değişmez, fatura üretmez.
      dealerGiveDeviceQuota: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/giveDeviceProductQuota", "PATCH");
        },
      }),
      dealerTakeBackDeviceQuota: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/takeBackDeviceProductQuota", "PATCH");
        },
      }),
      // ─── Bayi Cihaz Bilgi Düzenleme (devices.editInfo) ──────
      // Yalnız `note` alanı.
      dealerUpdateDeviceInfo: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/devices/dealerRoles/updateDevice", "PATCH");
        },
      }),
      // Bayinin plasiyer listesi (storage fetchPlayMaker ile aynı imza: token arg)
      fetchDealerPlayMaker: builder.query({
        query: (token) => ({
          url: "/api/users/dealerRoles/playmakers",
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
      }),
    };
  },
});

export const {
  useGetDealerRolesDeviceDetailQuery,
  useLazyGetDealerRolesDeviceDetailQuery,
  useLazyGetDealerRolesDeviceDistributionQuery,
  useGetDealerRolesDeviceConsumentStatsMutation,
  useGetDealerRolesDeviceConsumentLogsforReportMutation,
  useGetDealerRolesDeviceDetailPerformanceReportMutation,
  useGetDealerRolesDeviceSettingLogsforReportMutation,
  useGetDealerRolesDeviceOperationLogsforReportMutation,
  useGetDealerRolesDeviceSettingLogsPaginatedMutation,
  useGetDealerRolesDeviceOperationLogsPaginatedMutation,
  useDealerToggleDeviceActivityMutation,
  useDealerMoveDeviceToFirmMutation,
  useDealerMoveDeviceToPlaymakerMutation,
  useDealerMoveDeviceToServiceMutation,
  useDealerMoveDeviceToStorageMutation,
  useDealerGiveDeviceQuotaMutation,
  useDealerTakeBackDeviceQuotaMutation,
  useDealerUpdateDeviceInfoMutation,
  useFetchDealerPlayMakerQuery,
} = dealerDevicesApi;
export { dealerDevicesApi };
